export default __webpack_public_path__ + "static/media/markdown-sample.b8cb5441.md";